import Auth from './auth'

class Api {

    static getBaseUrl() {
        if (location.host === 'localhost:8080') {
            return 'https://local.api.theecoverse.net';
        } else {
            let arrayHost = location.host.split(".");
            if (['prism', 'adm1n'].indexOf(arrayHost[0]) > -1) {
                arrayHost.splice(0,1);
            }
            return 'https://api.' + arrayHost.join(".");
        }
    }

    static send(method, url, data) {

        const baseUrl = this.getBaseUrl();
        const loggedUser = Auth.getLoggedUser();
        const token = (loggedUser) ? loggedUser.token : "";

        return new Promise(function(resolve, reject) {
            let xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function() {
                    if (this.readyState == 4) {
                        const json = (this.responseText) ? JSON.parse(this.responseText) : null;
                        if (this.status == 200 || this.status == 201) {
                            resolve(json);
                        } else {
                            if (this.status == 401) {
                                Auth.deleteLoggedUser();
                                location.reload();
                            }
                            reject(json);
                        }
                    }
                };
                xhttp.open(method, baseUrl + url, true);
                xhttp.setRequestHeader('Bearer-Token', token);
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
                xhttp.setRequestHeader('Accept', 'application/json');
                xhttp.send(JSON.stringify(data));
        });

    }
}

export default Api
